import React from 'react'

function Footer() {
  return (
   <section id="footer">
    <div className="container">
        <p className='text-center' style={{color:'#1974d2',fontWeight:'500',fontSize:'1.2rem'}}>Copyright <i className="fa-solid fa-copyright" /> 2023 qrgen. All rights reserved. </p>
        <div className="row">

        </div>
    </div>
   </section>
  )
}

export default Footer